import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { environment } from '../../environments/environment';
import { oAuthApplication } from './oauth-application';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  private cachedToken?: string;

  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    if (!req.url.startsWith(environment.api.url)) {
      return next.handle(req);
    }

    const accessToken = this.resolveAccessToken();
    if (!accessToken) {
      return next.handle(req);
    }

    return next.handle(req.clone({
      setHeaders: { Authorization: `Bearer ${accessToken}` }
    }));
  }

  private resolveAccessToken(): string | undefined {
    if (this.cachedToken) {
      return this.cachedToken;
    }
    const token = oAuthApplication.getSession()?.accessToken?.access_token;
    if (token) {
      this.cachedToken = token;
    }
    return token;
  }
}
